import styles from "./SimilarContentCard.module.scss";
import { genresData } from "../../../../constants/structure";
import { useTranslation } from "react-i18next";
import { setCurrentItem } from "../../../../store/slices/currentItem.slice";
import { ROUTES } from "../../../../constants/routes";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import React from "react";
import { formatLikeCount, movieTitleHandler, posterPathHandler } from "../../../../utils/helpers";
import OverlayRatingIcon from "../../../../components/icons/searchIcons/OverlayRatingIcon";
import OverlayTomatoRatingIcon from "../../../../components/icons/searchIcons/OverlayTomatoRatingIcon";
import LikeButton from "../../../../components/shared/LikeButton";
import SavedIcon from "../../../../components/icons/searchIcons/savedIcon";
import { setLoginModal } from "../../../../store/slices/modals.slice";

type Movie = {
  id: number;
  genre_ids: number[];
  reviews_count: number | null;
  adult: boolean;
  backdrop_path: string;
  original_language: string;
  original_title: string;
  overview: string;
  overview_ru: string;
  overview_ua: string;
  popularity: number;
  poster_path: string;
  release_date: string;
  title: string;
  title_ru: string;
  title_ua: string;
  video: boolean;
  vote_average: number;
  vote_count: number;
  not_found: boolean;
  liked: boolean;
  imdb_rating?: number | null;
  imdb_votes?: number | null;
  kinopoisk_rating?: number | null;
  kinopoisk_votes?: number | null;
  rotten_tomatoes_rating?: number | null;
  rotten_tomatoes_audience_rating?: number | null;
};

const formatRating = (rating?: number | null) => (rating != null ? rating.toFixed(1) : undefined);

interface ISimilarContentCardProps {
  isMobile: boolean;
  movie: Movie;
  likeHandler: (e: any, item: any, liked: boolean) => void;
  updateFieldLocal: (id: any, item: any, field: any) => void;
  liked: boolean;
  isFav: boolean;
  favouritesHandler: (e: any, item: any, isFav: boolean) => void;
}

const SimilarContentCard = ({
  isMobile,
  movie,
  likeHandler,
  liked,
  isFav,
  favouritesHandler,
  updateFieldLocal,
}: ISimilarContentCardProps) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { t, i18n } = useTranslation();
  const title = movieTitleHandler(i18n.language, movie);
  const posterPath = posterPathHandler(i18n.language, movie);
  const primaryRating = formatRating(movie.imdb_rating ?? movie.vote_average);
  const secondaryRating = formatRating(movie.rotten_tomatoes_rating ?? movie.imdb_rating ?? movie.vote_average);

  return (
    <div
      onClick={(event) => {
        event.stopPropagation();
        event.preventDefault();
        dispatch(setCurrentItem(movie));
        navigate(`${ROUTES.DETAILS}/${movie.id}`);
        window.location.reload();
      }}
      className={styles.cardWrapper}
    >
      <div className={styles.imgSimilarWrapper}>
        {posterPath ? (
          <img
            width={119}
            height={166}
            className={styles.image}
            src={`${process.env.REACT_APP_IMG_BASE_URL}${posterPath}`}
            alt="#"
          />
        ) : (
          <div className={styles.image} style={{ width: 119, height: 166, background: "#1a1a1a", borderRadius: 8 }} />
        )}
      </div>
      <div className={styles.textWrapper}>
        <h4 className={styles.movieTitle}>{title}</h4>
        <div className={styles.infoWrapper}>
          <div className={styles.rowInfoWrapper}>
            <div className={styles.badge}>{movie.release_date?.substring(0, 4)}</div>
          </div>
          <p className={styles.description}>
            <span>
              {movie.genre_ids[0] && t(`${genresData.find((genre) => genre.id === movie.genre_ids[0])?.name}`)}{" "}
            </span>
            <span>
              {movie.genre_ids[1] && t(`${genresData.find((genre) => genre.id === movie.genre_ids[1])?.name}`)}
            </span>
          </p>
        </div>
        <div className={styles.cardActionsWrapper}>
          <div className={styles.ratingItem}>
            <OverlayRatingIcon />
            <p className={styles.rating}>{primaryRating}</p>
          </div>
          <div className={styles.ratingItem}>
            <OverlayTomatoRatingIcon />
            <p className={styles.rating}>{secondaryRating}</p>
          </div>
          <LikeButton
            count={formatLikeCount(movie.vote_count, { compact: true })}
            direction="row"
            isMobile={isMobile}
            liked={liked}
            clickHandler={likeHandler}
            updateFieldLocal={updateFieldLocal}
            item={movie}
            className={styles.likeButton}
          />
        </div>
      </div>
      <div
        className={styles.savedIconWrapper}
        onClick={(e) => {
          e.preventDefault();
          e.stopPropagation();
          const token = localStorage.getItem("accessToken");
          if (!token) {
            dispatch(setLoginModal(true));
            return;
          }

          favouritesHandler(e, movie, isFav);
        }}
      >
        <SavedIcon className={styles.savedIcon} inFavourites={isFav} />
      </div>
    </div>
  );
};

export default SimilarContentCard;
